import {
  Autocomplete,
  Box,
  Button, CircularProgress, Paper,
  TextField
} from "@mui/material";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import "./DueManagement.css";

const axios = require("axios").default;
//
const DueManagement = forwardRef((props, ref) => {

  
  useImperativeHandle(ref.dueListRef, () => ({
    getDueOrderList,
  }));

  const [loading, setLoading] = useState(false)
  const patientIdRedux = useSelector((state) => state.patientId);
  const [invoiceList, setInvoiceList] = useState([]);
  const [selectedOption, setSelectedOption] = useState({});
  const [selectedAmount, setSelectedAmount] = useState(0);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const paymentMethods = ["Cash", "Card", "Bkash", "Rocket", "Nagad"];
  const [paymentType, setPaymentType] = React.useState(paymentMethods[0]);

  const getDueOrderList = (patientId) => {
    // alert("OrderList From Due Managemnt ")
    axios
      .get("billing-due-management/due-orders/" + patientId)
      .then((response) => {
        console.log(response.data);
        let tempArray = [];

        response.data.map((item) => {
          const totalDue = item.total_bill - item.discount - item.total_paid;
          const tempItem = {
            value: item.id,
            label: "DUE: " + totalDue + " OID:" + item.id,
            amount: totalDue,
          };
          tempArray.push(tempItem);
        });
        setInvoiceList(tempArray);
      })
      .catch((errors) => {
        console.log(errors);
      });
  };

  const prepareInvoiceList = (serverOrderList) => {
    let tempList = [];
    serverOrderList.map((item) => {
      const totalDue = item.total_bill - item.discount - item.total_paid;
      if (totalDue > 0) {
        const tempItem = {
          value: item.id,
          label: `${item.id} - ${totalDue}`,
          amount: totalDue,
        };
        tempList.push(tempItem);
      }
    });
    return setInvoiceList(tempList);
    // return [
    //     { value: "chocolate", label: "Chocolate", id:1 },
    //     { value: "strawberry", label: "Strawberry", id:2 },
    //     { value: "vanilla", label: "Vanilla" , id:3},
    //   ];
  };

  const handleChange = (option) => {
    console.log("option", option);
    setSelectedOption(option);
    setSelectedAmount(parseInt(option.amount));
    setSelectedInvoiceId(option.value);
  };

  const resetFields = () => {
    setSelectedOption({});
    setSelectedAmount(0);
    setSelectedInvoiceId("");
    setPaidAmount(0);
  };
  // axios requrests
  const storeTransaction = () => {
    let proceedNext = true; 
    if(! selectedInvoiceId> 0  ){
      toast.error("Select due invoice first")
      proceedNext = false;
    }
    if(!paidAmount>0  ){
      toast.error("Paid amount should be more then 0. ")
      proceedNext = false;
    }
    if(proceedNext===false){
      return; 
    }
    setLoading(true)
    const data = {
      billing_order_master_id: selectedInvoiceId,
      dentrino_patient_info_id: patientIdRedux,
      tr_amount: paidAmount,
      payment_type: paymentType,
    };
    console.log({ ...data });
    // return;
    axios
      .post("/billing-order/payment/add-new-payment", { ...data })
      .then((response) => {
        setLoading(false)
        console.log(response);
        toast.success("Payment successfully receipt.");
        getDueOrderList(patientIdRedux);
        window.open("/bill-print/" + selectedInvoiceId);

        resetFields();
      })
      .catch((errors) => {
        setLoading(false)
        console.error(errors);
      });
  };
  // axios requrests //
  // handle Methods
  const handleOpenDetails = () => {
    console.log("selectedInvoiceId-", selectedInvoiceId);
    window.open("/bill-print/" + selectedInvoiceId);
  };
  // handle Methods //

  return (
    <>
      {/* <Controller
        name="dentrino_doctors_manager_id"
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            isClearable={true}
            isLoading={loading}
            placeholder={"Select Doctor"}
            styles={customStyles}
            options={doctorListData}
            defaultValue={DoctorList[0]}
          />
        )}
      /> */}

      <Paper
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px",
          margin: "10px",
        }}
      >
        <Box sx={{ display: "flex", margin: "10px 0 20px 0" }}>
          <Box sx={{ width: "200px" }}>
            <Select
              sx={{ zIndex: 10 }}
              value={selectedOption}
              onChange={handleChange}
              options={invoiceList}
            />
          </Box>
          <Box sx={{ width: "150px" }}>
            <TextField
              readOnly
              sx={{ mx: 1 }}
              size="small"
              label="Amount"
              value={selectedAmount}
            />
          </Box>
          <Button variant="outlined" onClick={handleOpenDetails}>
            DETAILS
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            margin: "10px 0 20px 0",
          }}
        >
          <Box sx={{ typography: "body1", marginRight: "10px" }}>
            Collection Amount
          </Box>
          <Button
            variant="outlined"
            onClick={() => setPaidAmount(selectedAmount)}
          >
            FILL
          </Button>
          <Box sx={{ width: "170px" }}>
            <TextField
              sx={{ mx: 1 }}
              size="small"
              label="Paid Amount"
              type="number"
              onChange={(e) => setPaidAmount(e.target.value)}
              value={paidAmount}
            />
          </Box>
          <Autocomplete
            sx={{ width: 150 }}
            required
            id="size-small-outlined"
            size="small"
            options={paymentMethods}
            value={paymentType}
            onChange={(event, newValue) => {
              console.log("newValue-", newValue);
              setPaymentType(newValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Payment Methods" />
            )}
          />
          {loading ? (
            // <CircularProgress />
            <Box sx={{  px: 3 }} >
              <CircularProgress   />
            </Box>
            // <Box sx={{ display: "flex", alignItems: "center", px: 5 }}>
            //   <CircularProgress size={40} sx={{ px: 2 }} />
            // </Box>
          ) : (
            <Button
              variant="outlined"
              color="success"
              onClick={storeTransaction}
            >
              PAY
            </Button>
          )}
        </Box>
      </Paper>
    </>
  );
});

export default DueManagement;
